import { render, staticRenderFns } from "./channelSkuMediaDialog.vue?vue&type=template&id=2bb6767a&"
import script from "./channelSkuMediaDialog.vue?vue&type=script&lang=ts&"
export * from "./channelSkuMediaDialog.vue?vue&type=script&lang=ts&"
import style0 from "./channelSkuMediaDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports